// Règles de validations des champs de formulaires formulaires

export default {
    required(langue) {
        return value => !!value || (langue && langue == 'en' ? 'Required field' : 'Champ obligatoire')
    },

    email(langue) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return value => pattern.test(value) || !value || (langue && langue == 'en' ? 'Invalid email' : 'Email invalide')
    },

    telephone(langue) {
        const pattern = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/
        return value => (pattern.test(value ? value.replace(/\s/g, '') : '')) || !value || (langue && langue == 'en' ? 'Invalid phone number' : 'Numéro de téléphone invalide')
    },

    max20(langue) {
        return value => value <= 20 || (langue && langue == 'en' ? 'Score between 0 and 20' : 'Note entre 0 et 20')
    },

    maxLength(len, langue) {
        return v => (v || '').length <= len || (langue && langue == 'en' ? 'Maximum size exceeded !' : 'Taille maximale dépassée !')
    },

    minLengthArray(len,langue) {
        return value =>  !value || value.length > len || (langue && langue == 'en' ? 'Required field' : 'Champ obligatoire')
    },

    accepterConcentement(langue) {
        return value => value == true || (langue && langue == 'en' ? "You must validate the consent" : "Vous devez valider le consentement")
    },

    accepterCertification(langue) {
        return value => value == true || (langue && langue == 'en' ? "You must certify the accuracy of your information" : "Vous devez certifier l'exactitude de vos informations")
    },

    sessionCochee(listeSessions, session, langue) {
        return (session && session.Id && session.Id > 0) || (listeSessions == null || listeSessions.length == 0) || (langue && langue == 'en' ? 'You must choose a session !' : 'Vous devez choisir une session concours !')
    },
    differentFrom(val, label, langue) {
        return v => !val || v != val || (langue && langue == 'en' ? "Value must be different from " + label : "La valeur doit être différente de celle de " + label)
    },
    dateInferieurDe(dateN, nbrYear, langue) {
        return this.verifierDate(dateN, nbrYear) || (langue && langue == 'en' ? 'Please verify your date of birth !' : 'Veuillez vérifier votre date de naissance !')
    },

    // Vérification 
    verifierDate(dateN, nbrYear) {
        if (!dateN || !(dateN instanceof Date)) {
            return true
        }        
        var anneNaissance = dateN.getFullYear()
        var anneAutorise = new Date().getFullYear() - nbrYear
        return (anneNaissance < anneAutorise)
    }
}